<template>
    <v-footer app dark color="#0d1b2a">
      <v-container>
        <v-row justify="space-between" align="center">
          <v-col cols="12" md="6">
            <p class="text-white">
              © {{ new Date().getFullYear() }} Holonet Galactic Encyclopedia. All rights reserved. <a href="/tos" class="text-primary">Terms of Service</a>
            </p>
          </v-col>
          <v-col cols="12" md="6" class="text-right">
            <p class="text-white">
              Powered by 
              <a href="https://starwars.fandom.com/wiki/Wookieepedia" target="_blank" class="text-primary">Wookieepedia</a> and 
              <a href="https://www.wikidata.org" target="_blank" class="text-primary">Wikidata</a>. 
              <br/>Inspired by the aesthetics of space-fantasy universes.
            </p>
          </v-col>
          <!-- <v-col cols="12" md="6" class="text-right">
            <v-btn text color="primary" class="mx-2" to="/">Home</v-btn>
            <v-btn text color="primary" class="mx-2" to="/about">About</v-btn>
            <v-btn text color="primary" class="mx-2" to="/contribute">Contribute</v-btn>
          </v-col> -->
        </v-row>
      </v-container>
    </v-footer>
  </template>
  
  <script>
  export default {
    name: "Footer",
  };
  </script>
  
  <style scoped>
  .v-footer {
    padding: 1px;
  }
  .text-right {
    text-align: right;
  }
  a {
  text-decoration: none;
  }
  a:hover {
    text-decoration: underline;
  }
  </style>